export function getApiHost(): string {
    const local = getIsLocal();

    let result: string = '';

    if(local ===true)
    {
        result = 'http://localhost:5000';
    }
    else
    {
        result = 'https://api.kidsradar.de';
    }

console.log(result);
    return result;

}


export function getLegaApiHost(): string {
    const local = getIsLocal();

    let result: string = '';

    if(local ===true)
    {
        result = 'http://localhost:5000';
    }
    else
    {
        result = 'https://legaapi.boas-enkler.de';
    }

    console.log(result);
    return result;

}

function getIsLocal(): boolean {
    return window.location.hostname == 'localhost';
}
